const common = {
  actions: {
    cancel: 'Cancelar',
    close: 'Cerrar',
    delete: 'Eliminar',
    edit: 'Editar',
    refresh: 'Actualizar',
    retry: 'Reintentar',
    save: 'Guardar',
  },
  dialog: {
    close: 'Cerrar el diálogo',
  },
  documentTitle: 'SpeedGauge Coach AI | Seguridad de flotas',
  dropdown: {
    clearSearch: 'Borrar búsqueda',
    clearSearchText: 'Borrar el texto de búsqueda',
    noMatchingOptions: 'No hay opciones coincidentes',
    searchLabel: 'Buscar {{label}}',
    searchPlaceholder: 'Buscar...',
  },
    header: {
      accountAndSettings: 'Cuenta y configuración',
      accountMenu: 'Menú de cuenta',
      adminDashboard: 'Panel de administración',
      allVehicles: 'Todos los vehículos',
      backToChat: 'Volver al chat',
      closeSidebar: 'Cerrar la barra lateral del chat',
      customer: 'Cliente:',
      loadingFleetList: 'Cargando la lista de flotas',
      loggingOut: 'Cerrando sesión...',
      newSession: 'Nueva sesión',
      openSidebar: 'Abrir la barra lateral del chat',
      returnToSafetyCenter: 'Volver a Safety Center',
      selectCustomer: 'Seleccionar cliente',
      selectVehicleGroup: 'Seleccionar grupo de vehículos',
      vehicleGroup: 'Grupo de vehículos:',
    },
    sidebar: {
      ariaLabel: 'Barra lateral del chat',
      collapse: 'Contraer barra lateral',
      coachSuggestions: 'Sugerencias de Coach',
      guidedTours: 'Recorridos guiados',
      help: 'Ayuda',
      history: 'Historial',
      newSession: 'Nueva sesión',
      newSessionTitle: 'Nueva sesión (nuevo chat)',
      recentChats: 'Chats recientes',
      savedPrompts: 'Indicaciones guardadas',
      settings: 'Configuración',
    },
  status: {
    loading: 'Cargando...',
    noResults: 'No se encontraron resultados.',
    saving: 'Guardando...',
  },
} as const;

export default common;